<div id="measurement-info-panel" class="measurement-info-panel">
    <div *ngIf="this.getInfoMessage()" class="message-panel">
        <mat-icon>info_outline</mat-icon>
        <div><span [innerHTML]="this.getInfoMessage()"></span>
            <ng-container *ngIf="this.getInfoAccentMessage()">
                <br>
                <span class="message-accent">
                    <mat-spinner class="me-1" [diameter]="15" *ngIf="downloadingData()"></mat-spinner>
                    {{this.getInfoAccentMessage()}}
                </span>
            </ng-container>
        </div>
    </div>
    <form class="measurement-form">
        <div id="units-container" class="measurement-unit-container">

            <mat-form-field class="measure-select-field form-ultra-slim">
                <mat-icon matPrefix svgIcon="line"></mat-icon>
                <mat-select class="measure-select " id="length-measure-system-select" [(value)]="this.unitLengthSelected"
                            [disableOptionCentering]="true"
                            (selectionChange)="changeLengthUnits($event)">
                    <mat-optgroup class="measure-unit-group" [label]="'Imperial'">
                        <mat-option [value]="'2'">Auto</mat-option>
                        <mat-option *ngFor="let unit of imperialLengthUnits | keyvalue"
                                    [value]="unit.value">{{ unit.value }}</mat-option>
                    </mat-optgroup>
                    <mat-optgroup class="measure-unit-group" [label]="'Metric'">
                        <mat-option [value]="'1'">Auto</mat-option>
                        <mat-option *ngFor="let unit of metricLengthUnits | keyvalue"
                                    [value]="unit.value">{{ unit.value }}</mat-option>
                    </mat-optgroup>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="measure-select-field form-ultra-slim">
                <mat-icon matPrefix svgIcon="poly"></mat-icon>
                <mat-select class="measure-select" id="area-measure-system-select" [(value)]="this.unitAreaSelected"
                            [disableOptionCentering]="true"
                            (selectionChange)="changeAreaUnits($event)">
                    <mat-optgroup class="measure-unit-group" [label]="'Imperial'">
                        <mat-option [value]="'2'">Auto</mat-option>
                        <mat-option *ngFor="let unit of imperialAreaUnits | keyvalue"
                                    [value]="unit.value">{{ unit.value }}</mat-option>
                    </mat-optgroup>
                    <mat-optgroup class="measure-unit-group" [label]="'Metric'">
                        <mat-option [value]="'1'">Auto</mat-option>
                        <mat-option *ngFor="let unit of metricAreaUnits | keyvalue"
                                    [value]="unit.value">{{ unit.value }}</mat-option>
                    </mat-optgroup>


                </mat-select>
            </mat-form-field>

            <mat-form-field class="measure-select-field form-ultra-slim">
                <mat-icon matPrefix svgIcon="angle"></mat-icon>
                <mat-select class="measure-select" id="slope-measure-system-select" [(value)]="this.unitSlopeSelected"
                            [disableOptionCentering]="true"
                            (selectionChange)="changeSlopeUnits($event)">
                        <mat-option *ngFor="let unit of slopeUnits | keyvalue"
                                    [value]="unit.value">{{ unit.value }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div id="length-container" class="measurement-container " *ngIf="showPlaceholder || enableLength ">
            <mat-checkbox [disabled]="showPlaceholder" [checked]="showLengths" (change)="toggleLengths()" class="measure-checkbox"
                          id="measure-length-checkbox">{{enableArea ? "Perimeter" : showPlaceholder ? "Length" : "Total Length"}}
            </mat-checkbox>
            <div >
                <span class="measure-value" *ngIf="!showPlaceholder"
                      id="measure-length-value">{{selectedFeature.getLength()}}</span>
                <span class="measure-value-placeholder" *ngIf="showPlaceholder"
                      matTooltip="Select a line or shape to get info" matTooltipPosition="above"
                      id="measure-length-placeholder">?</span>
                <span class="measure-unit-value" *ngIf="!showPlaceholder"
                      id="measure-length-unit-value">{{selectedFeature.getLengthUnit()}}</span>
                <app-copy-clipboard [disable]="showPlaceholder" [message]="'Copied to clipboard'"
                                    [tooltipPosition]="'above'"
                                    [value]="selectedFeature ? selectedFeature.getLength() : ''"></app-copy-clipboard>
            </div>
        </div>
        <div id="segment-lengths-container" class="measurement-container d-flex justify-content-between" *ngIf="showPlaceholder || enableLength" style="padding-bottom: 2px">
            <mat-checkbox [disabled]="showPlaceholder" [checked]="showLengthSegments" (change)="toggleLengthSegments()" class="measure-checkbox"
                          id="measure-segment-lengths-checkbox">Segment Lengths
            </mat-checkbox>
        </div>
        <div id="height-container" class="measurement-container " *ngIf="showPlaceholder || enableHeight">
            <mat-checkbox [disabled]="showPlaceholder" [checked]="showHeights" (change)="toggleHeights()" class="measure-checkbox"
                          id="measure-height-checkbox">Height
            </mat-checkbox>
            <div >
                <span class="measure-value" *ngIf="!showPlaceholder"
                      id="measure-height-value">{{selectedFeature.getHeight()}}</span>
                <span class="measure-value-placeholder" *ngIf="showPlaceholder"
                      matTooltip="Select a line or shape to get info" matTooltipPosition="above"
                      id="measure-height-placeholder">?</span>
                <span class="measure-unit-value" *ngIf="!showPlaceholder"
                      id="measure-height-unit-value">{{selectedFeature.getHeightUnit()}}</span>
                <app-copy-clipboard [disable]="showPlaceholder" [message]="'Copied to clipboard'"
                                    [tooltipPosition]="'above'"
                                    [value]="selectedFeature ? selectedFeature.getHeight() : ''"></app-copy-clipboard>
            </div>

        </div>


        <div class="measurement-container " *ngIf="showPlaceholder || enableCircumference ">
            <mat-checkbox [disabled]="showPlaceholder" [checked]="showCircumference" (change)="toggleCircumference()" class="measure-checkbox">Circumference
            </mat-checkbox>
            <div >
                <span class="measure-value" *ngIf="!showPlaceholder">{{selectedFeature.getCircumference()}}</span>
                <span class="measure-value-placeholder" *ngIf="showPlaceholder"
                      matTooltip="Select a line or shape to get info" matTooltipPosition="above">?</span>
                <span class="measure-unit-value" *ngIf="!showPlaceholder">{{selectedFeature.getCircumferenceUnit()}}</span>
                <app-copy-clipboard [disable]="showPlaceholder" [message]="'Copied to clipboard'"
                                    [tooltipPosition]="'above'"
                                    [value]="selectedFeature ? selectedFeature.getCircumference() : ''"></app-copy-clipboard>
            </div>

        </div>


        <div id="area-container" class="measurement-container " *ngIf="showPlaceholder || enableArea ">
            <mat-checkbox [disabled]="showPlaceholder" [checked]="showAreas" (change)="toggleAreas()" class="measure-checkbox"
                          id="measure-area-checkbox">Area
            </mat-checkbox>
            <div >
                <span class="measure-value" *ngIf="!showPlaceholder"
                      id="measure-area-value">{{selectedFeature.getArea()}}</span>
                <span class="measure-value-placeholder" *ngIf="showPlaceholder"
                      matTooltip="Select a line or shape to get info" matTooltipPosition="above"
                      id="measure-area-placeholder">?</span>
                <span class="measure-unit-value" *ngIf="!showPlaceholder"
                      id="measure-area-unit-value">{{selectedFeature.getAreaUnit()}}</span>
                <app-copy-clipboard [disable]="showPlaceholder" [message]="'Copied to clipboard'"
                                    [tooltipPosition]="'above'"
                                    [value]="selectedFeature ? selectedFeature.getArea() : ''"></app-copy-clipboard>
            </div>

        </div>

        <div class="measurement-container " *ngIf="showPlaceholder || enableRadius ">
            <mat-checkbox [disabled]="showPlaceholder" [checked]="showRadius" (change)="toggleRadius()" class="measure-checkbox">Radius
            </mat-checkbox>
            <div >
                <span class="measure-value" *ngIf="!showPlaceholder">{{selectedFeature.getRadius()}}</span>
                <span class="measure-value-placeholder" *ngIf="showPlaceholder"
                      matTooltip="Select a line or shape to get info" matTooltipPosition="above">?</span>
                <span class="measure-unit-value" *ngIf="!showPlaceholder">{{selectedFeature.getRadiusUnit()}}</span>
                <app-copy-clipboard [disable]="showPlaceholder" [message]="'Copied to clipboard'"
                                    [tooltipPosition]="'above'"
                                    [value]="selectedFeature ? selectedFeature.getRadius() : ''"></app-copy-clipboard>
            </div>
        </div>
        <div id="pitch-container" class="measurement-container d-flex justify-content-between" *ngIf="enableSlope || (showPlaceholder && mode3D)">
            <mat-checkbox [disabled]="showPlaceholder || slopePlaceholder" [checked]="showSlopes" (change)="toggleSlopes()" class="measure-checkbox"
                          id="measure-slope-checkbox">Pitch
            </mat-checkbox>
            <div class="align-items-baseline">
                <span class="measure-value" *ngIf="selectedFeature && selectedFeature.hasSlope() && (!showPlaceholder && !slopePlaceholder)"
                      id="measure-pitch-value">{{selectedFeature.getSlope()}}</span>
                <span class="measure-value-placeholder" *ngIf="showPlaceholder || (selectedFeature && (!selectedFeature.hasSlope() || !selectedFeature.isPlanar()))"
                      matTooltip="{{getSlopeMessage()}}"
                      matTooltipPosition="above"
                      id="measure-hide-pitch-value">?</span>
                <span class="measure-unit-value" *ngIf="selectedFeature && selectedFeature.hasSlope() && selectedFeature.isPlanar() && !showPlaceholder"
                      id="measure-slope-unit-value">{{selectedFeature.getSlopeUnit()}}</span>
                <app-copy-clipboard [disable]="showPlaceholder || !selectedFeature || !selectedFeature.hasSlope() || !selectedFeature.isPlanar()"
                                    [message]="'Copied to clipboard'"
                                    [tooltipPosition]="'above'"
                                    [value]="selectedFeature ? selectedFeature.getSlope() : ''"></app-copy-clipboard>
            </div>

        </div>
        <div id="elevation-container" class="measurement-container p-2 " *ngIf="enableElevation && !showPlaceholder">
            <span class="measure-name mat-font-body-md " id="measure-elevation-name">{{enableRelativeElevation ? "Relative height" : "Elevation"}}</span>
            <div >
                <span class="measure-value" *ngIf="selectedFeature "
                      id="measure-elevation-value">{{enableRelativeElevation ? selectedFeature.getRelativeElevation() : selectedFeature.getElevation()}}</span>
                <span class="measure-value-placeholder" matTooltip="Select a line or shape to get info"
                      matTooltipPosition="above" *ngIf="!selectedFeature" id="measure-elevation-placeholder">?</span>
                <span class="measure-unit-value" *ngIf="selectedFeature "
                      id="measure-elevation-unit-value">{{enableRelativeElevation ? selectedFeature.getRelativeElevationUnit() : selectedFeature.getElevationUnit()}}</span>

                <app-copy-clipboard [disable]="!selectedFeature" [message]="'Copied to clipboard'"
                                    [tooltipPosition]="'above'"
                                    [value]="enableRelativeElevation ? selectedFeature.getRelativeElevation() : selectedFeature.getElevation()"></app-copy-clipboard>
            </div>

        </div>
        <div id="ground-elevation-container" class="measurement-container p-2" *ngIf="debugMode && enableGroundElevation && !showPlaceholder">
            <span class="measure-name mat-font-body-md " id="measure-ground-elevation-name">Ground</span>
            <div >
                <span class="measure-value" *ngIf="selectedFeature "
                      id="measure-ground-elevation-value">{{selectedFeature.getGroundElevation() }}</span>
                <span class="measure-value-placeholder" matTooltip="Select a line or shape to get info"
                      matTooltipPosition="above" *ngIf="!selectedFeature" id="measure-ground-elevation-placeholder">?</span>
                <span class="measure-unit-value" *ngIf="selectedFeature "
                      id="measure-ground-elevation-unit-value">{{selectedFeature.getGroundElevationUnit()}}</span>

                <app-copy-clipboard [disable]="!selectedFeature" [message]="'Copied to clipboard'"
                                    [tooltipPosition]="'above'"
                                    [value]="selectedFeature ? selectedFeature.getGroundElevation() : ''"></app-copy-clipboard>
            </div>

        </div>
        <div id="latitude-container" class="measurement-container p-2" *ngIf="enableLocation && !showPlaceholder">
            <span class="measure-name mat-font-body-md " id="measure-latitude-name">Lat/Long</span>
            <div >
                <span class="px-2 measure-value"
                      id="measure-latitude-value">{{selectedFeature.getLocation()[1] | number : '1.6-6'}},</span>
                <span class="px-2 measure-value"
                      id="measure-longitude-value">{{selectedFeature.getLocation()[0] | number: '1.6-6'}}</span>
                <app-copy-clipboard [message]="'Copied to clipboard'" [tooltipPosition]="'above'"
                                    [value]="getLocation()"></app-copy-clipboard>
            </div>

        </div>
        <div id="info-container" class="measurement-container p-2 " *ngIf="debugMode && !showPlaceholder && enableInfo">
            <span class="measure-name mat-font-body-md " id="measure-type-name">Type</span>
            <div >
                <span class="measure-value"
                      id="info-mode-value">{{selectedFeature.getInfo().type}}</span>

            </div>
            <span class="measure-name mat-font-body-md " id="measure-survey-name">Survey</span>
            <div >
                <span class="measure-value"
                      id="info-survey-value">{{selectedFeature.getInfo().survey}}</span>
                <app-copy-clipboard [message]="'Copied geojson to clipboard'" [tooltipPosition]="'above'"
                                    [value]="selectedFeature.geometry | json"></app-copy-clipboard>
            </div>


        </div>
    </form>
</div>


